import { FetchResourceError } from '../types/FetchResourceError';

export default (japiDocument: any): japiDocument is FetchResourceError => typeof japiDocument === 'object' && 'errors' in japiDocument && !('data' in japiDocument);
